"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initOngoingRefresh = exports.resolveOngoingRefresh = exports.refreshToken = void 0;
const refresh_1 = require("./apis/refresh");
const setTokens_1 = require("./setTokens");
const eventManager_1 = require("../utils/eventManager");
const config_1 = require("../utils/config");
const cookieManager_1 = require("../utils/cookieManager");
const broadcastChannel_1 = require("../utils/broadcastChannel");
const newRelicEvents_1 = require("../utils/newRelicEvents");
let $ongoingRefresh;
let $resolve = () => { };
function refreshToken() {
    return __awaiter(this, void 0, void 0, function* () {
        if (typeof window === 'undefined')
            return;
        try {
            if ($ongoingRefresh) {
                return $ongoingRefresh;
            }
            newRelicEvents_1.sendNewRelicEvent({ EventName: 'refresh_start' });
            broadcastChannel_1.getBroadcastChannel().postMessage({ action: 'refreshStart' });
            $ongoingRefresh = refresh_1.refresh();
            const tokens = yield $ongoingRefresh;
            const { idToken, accessToken } = tokens;
            $ongoingRefresh = null;
            broadcastChannel_1.getBroadcastChannel().postMessage({ action: 'refreshEnd', payload: { tokens } });
            newRelicEvents_1.sendNewRelicEvent({ EventName: 'refresh_success' });
            yield setTokens_1.setTokens({
                idToken,
                accessToken,
                callInitSession: false,
                broadcast: true,
                authActionType: 'refresh_token',
            });
            return tokens;
        }
        catch (err) {
            $ongoingRefresh = null;
            if (err.code == 'invalid_grant') {
                newRelicEvents_1.sendNewRelicEvent({ EventName: 'refresh_fail', reason: 'invalid grant' });
                cookieManager_1.removeCookies(config_1.getCookieDomain());
                eventManager_1.emit('logout.success');
            }
            else {
                newRelicEvents_1.sendNewRelicEvent({ EventName: 'refresh_fail', reason: err });
                eventManager_1.triggerError('refresh', err);
            }
            broadcastChannel_1.getBroadcastChannel().postMessage({ action: 'refreshEnd' });
        }
    });
}
exports.refreshToken = refreshToken;
function initOngoingRefresh() {
    $ongoingRefresh = new Promise((resolve) => {
        $resolve = resolve;
    });
}
exports.initOngoingRefresh = initOngoingRefresh;
function resolveOngoingRefresh(tokens) {
    $ongoingRefresh = null;
    $resolve(tokens);
    $resolve = () => { };
}
exports.resolveOngoingRefresh = resolveOngoingRefresh;
